/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import size from 'lodash.size';
import searchingGIF from '../assets/images/searching.gif';
import { request, formatPatientId, patientname } from '../services/utilities';
import { searchAPI } from '../services/constants';
import { toggleProfile } from '../actions/user';

const SearchPatient = ({
	slug,
	setSelectedStaff,
	selectedStaff,
	setFocus: setFocusAlt,
	setShowModal,
	style,
	onExit,
	focus,
	toggleProfile,
}) => {
	const [search, setSearch] = useState('');
	const [focused, setFocused] = useState(false);
	const [searching, setSearching] = useState(false);
	const [patients, setPatients] = useState([]);
	const [hasSearched, setHasSearched] = useState(false);
	// const [focus, setFocus]

	const searchInputRef = useRef(null);

	// Handle Enter key search
	useEffect(() => {
		const listener = e => {
			if ((e.code === 'Enter' || e.code === 'NumpadEnter') && search !== '') {
				e.preventDefault();
				doSearch();
			}
		};
		const inputEl = searchInputRef.current;
		if (inputEl) inputEl.addEventListener('keydown', listener);

		return () => {
			if (inputEl) inputEl.removeEventListener('keydown', listener);
		};
	}, [search]);

	// Focus input on mount if needed
	useEffect(() => {
		if (focus && !focused) {
			setTimeout(() => {
				setFocus();
			}, 100);
		}
	}, [focus, focused]);

	// Handle hiding
	useEffect(() => {
		if (style?.display === 'none' && focused) {
			setFocused(false);
			setSearch('');
			setPatients([]);
		}
	}, [style, focused]);

	const setFocus = () => {
		setFocused(true);
		setHasSearched(false);
		setTimeout(() => {
			if (searchInputRef.current) {
				searchInputRef.current.click();
				searchInputRef.current.focus();
			}
		}, 10);
	};

	const closeSearch = () => {
		setFocusAlt(false);
	};

	const doSearch = async term => {
		if (size(search) >= 1) {
			try {
				setSearching(true);
				setHasSearched(true);
				const url = `hr/staffs?page=1&limit=10&q=${term || search}&status=&include_stats=1&department_id&${slug && `role_slug=${slug}`}`;
				const result = await request(url, 'GET', true);
				setPatients(result?.result);
			} catch (e) {
				console.error(e);
			} finally {
				setSearching(false);
			}
		} else {
			setSearching(false);
			setPatients([]);
			setHasSearched(false);
		}
	};

	const showProfile = patient => {
		if (patient) {
			// const info = { patient, type: 'staff' };
			setShowModal(true);
			//   toggleProfile(true, info);
			//   toggleStaffAnalysis(true, info)
		}
	};

	return (
		<div className="search-with-suggestions-w over-search-field" style={{ display: 'flex' }}>
			<div className="search-with-suggestions-modal">
				<div className="element-search" style={{ marginBottom: 0 }}>
					<input
						className="search-suggest-input"
						ref={searchInputRef}
						placeholder="Search for a staff..."
						type="text"
						value={search}
						onChange={e => {
							setSearch(e.target.value);
							doSearch(e.target.value);
						}}
					/>
					<div className="btn-search-suggestions" onClick={doSearch}>
						<i className="os-icon os-icon-ui-37" />
					</div>
					<div className="close-search-suggestions" onClick={closeSearch}>
						<i className="os-icon os-icon-x" />
					</div>
				</div>

				{searching && (
					<div className="searching">
						<img alt="searching" src={searchingGIF} />
					</div>
				)}

				{!searching && (
					<div className="search-suggestions-group" style={{ marginTop: '30px' }}>
						<div className="ssg-header">
							<div className="ssg-icon">
								<div className="os-icon os-icon-users"></div>
							</div>
							<div className="ssg-name">Staffs</div>
							<div className="ssg-info">{patients.length} Total</div>
						</div>
						<div className="ssg-content">
							<div style={{ maxHeight: '65vh' }} className="ssg-items ssg-items-list modal-scroll">
								{patients.length === 0 && hasSearched && <div className="alert alert-danger">No Staff Record(s) Found!</div>}
								{patients.map(p => (
									<div style={{ display: 'flex' }} key={p.id}>
										<a
											onClick={() => {
												setSelectedStaff(p);
												showProfile(p);
											}}
											className="ssg-item cursor"
										>
											<div className="item-name">
												{p?.first_name} &nbsp; {p?.last_name}
											</div>
										</a>
									</div>
								))}
							</div>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default connect(null, { toggleProfile })(SearchPatient);
